export default __webpack_public_path__ + "static/char-t-21-ja-b1b3c5d54e544043fb73c7776ab596b1.webp";